<template>
  <b-container fluid>
    <b-row style="margin-top: -17px" class="">
      <b-col lg="3" class="p-0">
        <NavAdmin
          :clearance="details.clearance"
          :level="details.clearance_level"
        ></NavAdmin>
      </b-col>

      <b-col lg="9" xs="12" class="m-0 p-0 bg-white">
        <div class="nav-admin-header">
          <NavHeaderAdmin parent="admin" />
        </div>
        <div class="p-3 view-wrapper" >
          <router-view class="bg-white"></router-view>
        </div>
        
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import store from "@/store";
import { mapActions, mapState } from "vuex";
import NavAdmin from "@/components/admin/NavAdmin.vue";
import NavHeaderAdmin from "@/components/admin/NavHeaderAdmin.vue";
import refreshLogin from "@/mixings/refreshLogin";

export default {
  components: {
    NavAdmin,
    NavHeaderAdmin
  },
  mixings : [refreshLogin],
  data() {
    return {
      leaving: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    // store.dispatch("admin/fetchCategories");
    // store.dispatch("admin/fetchQuestions");
    // store.dispatch("admin/fetchInstitutions");
    // store.dispatch("admin/fetchTestspaces");
    store.dispatch("admin/fetchAllTopics");
    store.dispatch("admin/fetchQuestionsall");
    store.dispatch("admin/queryQStocked");
    store.dispatch("admin/queryStocks");
    store.dispatch("admin/fetchOrganization");
    store.dispatch("admin/fetchOrganizationplan");
    store.dispatch("admin/fetchCompanymetrics");
    store.dispatch("admin/fetchContents");
    store.dispatch("admin/getAllUsers");
    store.dispatch("admin/fetchDiscountDetails");

    let orgname = store.state.loginmaster.details.clearance_organization;
    // console.log(orgname)
    store.dispatch("admin/fetchOrgadmins", { orgname: orgname });
    next();
  },

  async mounted() {

    if (this.loggedin) {
      this.goLand();
    } else {
      let remember = this.getCookie("remember");

      console.log(remember)

      if (remember == 1) {
        let sqid = this.getCookie("qid");
        let details = {
          qid: sqid,
          page: "landing"
        };

        return await this.sendLogin(details).then(() => {
          this.goLand();
          store.dispatch("admin/fetchCategories");
          store.dispatch("admin/fetchQuestions");
          store.dispatch("admin/fetchInstitutions");
          store.dispatch("admin/fetchTestspaces");
          store.dispatch("admin/fetchAllTopics");
          store.dispatch("admin/fetchQuestionsall");
          store.dispatch("admin/queryQStocked");
          store.dispatch("admin/queryStocks");
          store.dispatch("admin/fetchOrganization");
          store.dispatch("admin/fetchOrganizationplan");
          store.dispatch("admin/fetchCompanymetrics");
          store.dispatch("admin/fetchContents");
          store.dispatch("admin/getAllUsers");
          store.dispatch("admin/fetchDiscountDetails");
          store.dispatch("admin/fetchNotifications");

          let orgname = store.state.loginmaster.details.clearance_organization;
          // console.log(orgname)
          store.dispatch("admin/fetchOrgadmins", { orgname: orgname });
        });
      } else {
        this.$router.push({
          name: "login",
          query: { redirect: this.$route.fullPath }
        });
      }
    }

},

  created() {
    // if (!this.loggedin) {
    //   this.$router.push({
    //     name: "landing",
    //     query: { redirect: this.$route.fullPath },
    //   });
    // }

    if (this.details.clearance_level == 0) {
      this.$router.push({
        name: "dashboard",
      });
    }
  },
  methods: {
    ...mapActions("exam", ["addQuestion"]),
  },
  computed: {
    ...mapState({
      details: (state) => state.loginmaster.details,
      loggedin: (state) => state.loginmaster.loggedIn,
      environ: (state) => state.loginmaster.environ,
    }),
  },
};
</script>

<style scoped>
.base-select {
  padding: 10px;
}

.btn-sub {
  font-size: 18px;
  font-weight: bold;
  color: blue;
  cursor: pointer;
}
.nav-admin-header{
  height: 80px;
  position: fixed;
  background: white;
  z-index: 999;
  width: 75%;
  box-shadow: 2px 2px 3px 0px ;
  margin-bottom: 10px
}

.view-wrapper{
  margin-top:100px;
}

@media screen and (max-width: 999px) {
  .nav-admin-header{
    width: 103%;
    box-shadow: 2px 2px 3px 0px ;
    margin-bottom: 10px;
  }
}
</style>
